import React from "react";

export function ForkIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      {...rest}
    >
      <path
        d="M20.0938 35C20.0938 35.4142 20.4295 35.75 20.8438 35.75C21.258 35.75 21.5938 35.4142 21.5938 35H20.0938ZM21.5938 35C21.5938 26.8998 21.2906 21.7473 19.6611 17.8365C18.0062 13.8648 15.0263 11.2609 9.99125 8.114L9.19625 9.386C14.1612 12.4891 16.8063 14.8852 18.2764 18.4135C19.7719 22.0027 20.0938 26.8502 20.0938 35H21.5938Z"
        fill="currentColor"
        vectorEffect={vectorEffect}
      />
      <path
        d="M3.77281 5.58788C3.48036 4.71051 4.15368 3.82706 5.07719 3.87642L12.7098 4.28443C13.7769 4.34147 14.3602 5.56721 13.72 6.40714L8.5044 13.2505C7.86425 14.0904 6.52771 13.8529 6.18982 12.8392L3.77281 5.58788Z"
        fill="currentColor"
        vectorEffect={vectorEffect}
      />
      <path
        d="M38.067 5.58788C38.3595 4.71051 37.6862 3.82706 36.7627 3.87642L29.13 4.28443C28.063 4.34147 27.4797 5.56721 28.1198 6.40714L33.3354 13.2505C33.9756 14.0904 35.3121 13.8529 35.65 12.8392L38.067 5.58788Z"
        fill="currentColor"
        vectorEffect={vectorEffect}
      />
      <path
        d="M31.6963 8.114C32.0475 7.89447 32.5102 8.00125 32.7297 8.3525C32.9493 8.70375 32.8425 9.16647 32.4912 9.386L31.6963 8.114ZM20.0938 35C20.0938 26.8998 20.3969 21.7473 22.0264 17.8365C23.6813 13.8648 26.6612 11.2609 31.6963 8.114L32.4912 9.386C27.5263 12.4891 24.8812 14.8852 23.4111 18.4135C21.9156 22.0027 21.5938 26.8502 21.5938 35H20.0938Z"
        fill="currentColor"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
